import apiClient from './api';

export const getOrganizations = async () => {
    const response = await apiClient.get(`/organization`);
    return response.data;
}

